
import axios from 'axios';
import { useAuthStore } from '../stores/usuarios/auth.store';
const url = process.env.REACT_APP_API_URL;




export const apiClientServer = (endpoint='', type='admin') => {
    const instance = axios.create({
        baseURL: `${url}/${endpoint}`,
    });

    instance.interceptors.request.use((config) => {
        const state = useAuthStore.getState();
        // const token = type === 'cliente' ? state.tokenCliente : state.token;
        const token = state.tokenCliente || state.token;
        if(token) { config.headers = { ...config.headers, 'x-token': token }; }
        return config;
    });

    return instance;
};